import script from "./TopBarButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./TopBarButton.vue?vue&type=script&setup=true&lang=ts"

import "./TopBarButton.vue?vue&type=style&index=0&id=3cd3de0b&lang=scss"

const __exports__ = script;

export default __exports__